const isDev = import.meta.env.MODE === 'development';

const isStage = import.meta.env.VITE_NODE_ENV === 'stage';

const isProd = import.meta.env.VITE_NODE_ENV === 'production';

const isPreProd = import.meta.env.VITE_NODE_ENV === 'preproduction';

const imageExtensions = 'JPG, PNG, WebP';

const videoExtensions = 'MP4, MOV, AVI, WebM';

const imageAccept = 'image/jpeg,image/png,image/webp';

const videoAccept = 'video/mp4,video/quicktime,video/x-msvideo,video/webm';

const MAX_FILE_SIZE_MB = 10;

const MAX_FILE_SIZE_BYTES = MAX_FILE_SIZE_MB * 1024 * 1024;

const TOOL_ID = 'gen-ai';

const FOLDER_NAME = 'GenAI';

const MINIAPP_PACKAGE_ID = 'com.picsart.genai-studiov2';

const MINIAPP_PACKAGE_IDS = {
  REPORTING: 'com.picsart.social.reporting',
  INVITATION: 'com.picsart.social.invitation-screen',
  EXPORT_SHARE: 'com.picsart.edit.export-and-share',
};

const subscriptionToolId = 'genai-studio-v2-generic';

export {
  isDev,
  isStage,
  isProd,
  isPreProd,
  imageExtensions,
  videoExtensions,
  imageAccept,
  videoAccept,
  MAX_FILE_SIZE_MB,
  MAX_FILE_SIZE_BYTES,
  TOOL_ID,
  FOLDER_NAME,
  MINIAPP_PACKAGE_ID,
  MINIAPP_PACKAGE_IDS,
  subscriptionToolId,
};
